import { render } from "./TabAddresses.vue?vue&type=template&id=1d6450ad"
import script from "./TabAddresses.vue?vue&type=script&lang=js"
export * from "./TabAddresses.vue?vue&type=script&lang=js"

import "./TabAddresses.vue?vue&type=style&index=0&id=1d6450ad&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__